<template>
  <div class="admin_bg">
    <Header :user="user" :token="token" :txt="'在线学习'" @to-logout="toLogout" @to-reg="toReg" @to-record="toRecord"></Header>
    <div class="wrap w1200 local">
      首页 - 平台管理中心 - {{currentPath}}
    </div>
    <div class="wrap w1200">
      <div class="col_1 w222 left_con">
        <Accordion :model="menus" @route-changed="routeChanged"></Accordion>
      </div>
      <div class="w978 w_bg col_2">
        <router-view></router-view>
        <div class="clear"></div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import Header from '@/components/byl/header/header.vue'
  import Accordion from '@/components/common/accordion/index.vue'
  import { mapState, mapActions } from 'vuex'
  export default {
    components: { Header, Accordion },
    data () {
      return {
        currentPath: this.$route.name
      }
    },
    computed: {
      ...mapState('auth', ['user', 'token']),
      ...mapState('sysmenus', ['menus'])
    },
    methods: {
      ...mapActions('auth', {
        logout: 'logout'
      }),
      toLogout () {
        this.logout()
      },
      toReg () {
        this.$router.push('/byl/orgreg')
      },
      toRecord () {
        this.$router.push('/Record')
      },
      routeChanged (route) {
        this.currentPath = route.name
      }
    }
  }
</script>
<style lang="scss">
  @import "../../../assets/scss/platform";
</style>



// WEBPACK FOOTER //
// src/page/byl/sys/index.vue